<template>
    <div class="campaign-builder-modal">
        <DsModal
            is-open
            size="lg"
            class="integration-modal"
            data-qa="integration-modal"
            :title="cell.value.name"
            @close="closeModal"
        >
            <template #default>
                <iframe
                    ref="iframeRef"
                    class="external-config-frame"
                    :src="iframeUrl"
                />
            </template>
        </DsModal>
    </div>
</template>

<script>

const MESSAGE_TYPES = {
    LOADED: 'loaded',
    SAVE: 'save',
    CLOSE: 'close',
    STATUS: 'status',
};

export default {
    props: {
        enabledIntegrations: {
            type: Array,
            default: () => [],
        },
        cell: {
            type: Object,
            default: () => ({
                value: {
                },
            }),
        },
    },
    emits: ['update-cell-value', 'close-modal'],

    computed: {
        iframeUrl() {
            const url = new URL(this.enabledIntegrations.find((integration) => integration.id === this.cell.value.integrationActionId)?.appBaseUrl);

            return url.toString();
        },
    },

    async mounted () {
        window.addEventListener('message', this.receiveMessage);
    },

    beforeUnmount () {
        window.removeEventListener('message', this.receiveMessage);
    },

    methods: {
        receiveMessage (event) {
            const { data: { type } } = event;

            if (type === MESSAGE_TYPES.CLOSE) {
                this.closeModal();
            } else if (type === MESSAGE_TYPES.SAVE) {
                const {
                    data: {
                        ready,
                    },
                } = event;

                this.updateConfig(ready);
            } else if (type === MESSAGE_TYPES.LOADED) {
                const message = {
                    type: 'init',
                    ready: this.cell.isReady ? this.cell.isReady : 0,
                };

                this.$refs.iframeRef.contentWindow.postMessage(message, '*');
            } else if (type === MESSAGE_TYPES.STATUS) {
                const { data: { ready } } = event;

                this.updateReady(ready);
            }
        },

        closeModal() {
            this.$emit('close-modal');
        },

        async updateConfig(isReady) {
            const updatedCell = { ...this.cell };

            try {
                this.$emit('update-cell-value', { cell: updatedCell, isReady });
            } catch (e) {
                const message = {
                    type: 'error',
                    errorMessage: e.response.data,
                };

                this.$refs.iframeRef.contentWindow.postMessage(message, '*');
            }
        },

        updateReady(isReady) {
            const updatedCell = { ...this.cell };

            this.$emit('update-cell-value', { cell: updatedCell, preventClose: true, isReady });
        },
    },
};
</script>

<style lang="scss" scoped>
.integration-modal {
    padding: 0;
}

.external-config-frame {
    width: 100%;
    height: 75vh;
}
</style>
